module.exports = __webpack_public_path__ + "static/media/focus.6932b791.svg";